import React from 'react'
import '../styles/direc.css'

const Direc = () => {
  return (
    <div className='direc-cont'>
        <h3 className="domicilio">Alvarez #38 plaza "San Charly" Centro Iguala,Gro.</h3>
    </div>
  )
}

export default Direc